// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i7G1","delete":"styles_delete__1NJlb","update":"styles_update__8osrT","add":"styles_add__1or3F"};